import { cookie } from '@sfe/bone-cache';

export default () => {
    // 尝试获取ga的clientId
    if (window.ga) {
        const tracingList = (window.ga.getAll && window.ga.getAll()) || [];
        if (tracingList.length) {
            return tracingList[0].get('clientId');
        }
    }
    // 不一定有 window.ga 所以直接取cookie
    const cookieGa = cookie.get('_ga');
    if (cookieGa) {
        return cookieGa.slice(6);
    }
    return 'none client id';
};
